import { Reveal, SectionLabel } from "./Reveal";

const steps = [
  {
    num: "01",
    title: "Kostenloses Erstgespräch",
    text: "Wir telefonieren 20 Minuten. Du erzählst, was dein Betrieb macht — ich sage dir ehrlich, was deine Website braucht und was sie kostet.",
  },
  {
    num: "02",
    title: "Konzept & Design",
    text: "Du bekommst einen ersten Entwurf zum Anschauen. Wir passen an, bis es passt — du musst nichts selbst schreiben oder gestalten.",
  },
  {
    num: "03",
    title: "Umsetzung",
    text: "Ich baue deine Website: schnell, mobilfreundlich und so, dass Google dich findet. Du bekommst regelmäßig Zwischenstände.",
  },
  {
    num: "04",
    title: "Launch & Betreuung",
    text: "Deine Seite geht online. Auf Wunsch übernehme ich danach Pflege, Updates und Änderungen — du hast einen festen Ansprechpartner.",
  },
];

export default function Process() {
  return (
    <section id="prozess" className="py-20 md:py-32 bg-[#0A0A0A] text-white relative grain">
      <div className="max-w-6xl mx-auto px-5 md:px-8 relative z-10">
        <Reveal>
          <div className="flex items-center gap-3 mb-6">
            <span className="font-mono text-xs font-medium text-[#60A5FA]">04</span>
            <span className="h-px w-8 bg-[#60A5FA]" aria-hidden="true" />
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/50">So läuft's ab</span>
          </div>
          <h2 className="font-display font-medium text-3xl md:text-4xl lg:text-5xl tracking-tight max-w-2xl">
            Vier Schritte. Kein Risiko. Keine Überraschungen.
          </h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {steps.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.12} className="h-full">
              <div className="h-full bg-[#0A0A0A] p-8 hover:bg-white/[0.04] transition-colors duration-300" data-testid={`process-step-${i}`}>
                <p className="font-mono text-4xl font-medium text-[#2563EB]">{s.num}</p>
                <h3 className="mt-6 font-display font-semibold text-lg tracking-tight">{s.title}</h3>
                <p className="mt-3 text-sm text-white/60 leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <p className="mt-10 font-mono text-xs text-white/40 text-center">
            Ø Projektdauer: 2–4 Wochen vom Erstgespräch bis zur fertigen Website
          </p>
        </Reveal>
      </div>
    </section>
  );
}
